import Setup from '@/helpers/Setup'

export default {
  state: {
    initial_loading_done: false,
  },
  mutations: {
    INITIAL_LOADING_DONE: state => (state.initial_loading_done = true),
  },
  actions: {
    initGoorder({ dispatch }) {
      return Promise.allSettled([
        dispatch('setUIDefaultSettings'),
        dispatch('load_root_stores'),
        dispatch('load_goorder_settings'),
        dispatch('load_settings'),
        dispatch('load_goorder_language'),
        dispatch('load_brands'),
        dispatch('load_currencies'),
        dispatch('load_web_translations'),
        dispatch('load_languages'),
        dispatch('load_timezones'),
        dispatch('load_root_order_discounts'),
        dispatch('load_goorder_types'),
        dispatch('load_countries'),
        dispatch('load_business_types'),
        dispatch('load_goorder_price_ranges'),
        dispatch('load_goorder_kitchen_types'),
        dispatch('load_new_style_delivery_areas'),
        dispatch('load_all_store_delivery_areas_by_value'),
      ])
    },
    initBrand({ dispatch }) {
      return Promise.allSettled([
        dispatch('load_brand_stores'),
        dispatch('setCustomSettings'), //--here
        dispatch('load_settings'),
        dispatch('load_currencies'),
        dispatch('load_web_translations'),
        dispatch('load_languages'),
        dispatch('load_timezones'),
        dispatch('load_countries'),
        dispatch('load_business_types'),
        dispatch('load_new_style_brand_delivery_areas'),
      ])
    },
    postLoad({ dispatch, getters }) {
      dispatch('load_static_pages')
      dispatch('load_customer', true)
      if (getters.domainBasedBrand) {
        dispatch('postBrandLoad')
      } else {
        dispatch('postGoorderLoad')
      }
    },
    postBrandLoad() {},
    postGoorderLoad() {},
    initializeSystem({ commit, dispatch, getters }) {
      dispatch('attach_service_worker')
      dispatch('getUserCountry')
      dispatch('login').then(() => {
        let dispatchActions = 'initGoorder'
        let versionsAction = 'load_core_versions'
        if (getters.domainBasedBrand) {
          dispatchActions = 'initBrand'
          versionsAction = 'load_brand_versions'
        }
        dispatch(versionsAction).then(() => {
          
          Promise.allSettled([Setup.install(), dispatch(dispatchActions)]).then(
            () => {
              try {
                dispatch('initializeContext').then(() => {
                  try {
                    if (getters.isFloorTableAvailable.table_id) {
                      dispatch(
                        '_getFloorTableInformation',
                        getters.isFloorTableAvailable
                      )
                        .then(() => {})
                        .catch(() => {})
                    }
                  } catch (e) {}
                  commit('INITIAL_LOADING_DONE')
                  Promise.allSettled([
                    dispatch('determineCurrentLanguage'),
                    dispatch('load_offers'),
                  ])
                    .then(() => {
                      if (getters.domainBasedBrand) {
                        dispatch('loadCatalog').then(() => {
                          // dispatch('restoreCart')
                          commit('FINISH_SETTING_CONTEXT')
                          dispatch('postLoad')
                        })
                      } else {
                        dispatch('postLoad')
                        commit('FINISH_SETTING_CONTEXT')
                      }
                    })
                    .catch(er => {})
                })
                //business type we need normally for goorder
                if (getters.goorder) {
                  for (var availableBT of getters.all_business_types) {
                    if (
                      availableBT.name.toLowerCase() ==
                      'Restaurant'.toLowerCase()
                    ) {
                      dispatch('setBusinessType', availableBT)
                      break
                    }
                  }
                }
              } catch (e) {}
            }
          )
        })
      })
    },
  },
  getters: {
    initial_loading_done: state => state.initial_loading_done,
  },
}
